<pages-container
  [title]="'main.additionalFrontUserInfo'"
  [icon]="'account_box'">
  <div buttons>
    <button mat-raised-button
            class="mat-white-bg"
            (click)="newType()">
      <span>{{ 'main.add' | translate }}</span>
    </button>
  </div>

  <div main-content class="table-container">
    <mat-table class="products-table"
               #table
               [dataSource]="dataSource"
               matSort>

      <!-- Title Column -->
      <ng-container matColumnDef="title">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'additionalFrontUserInfo.title' | translate }}
        </mat-header-cell>
        <mat-cell *matCellDef="let item">
          <p class="text-truncate">{{ item.title }}</p>
        </mat-cell>
      </ng-container>

      <!-- Active Column -->
      <ng-container matColumnDef="active">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="status">
          {{ 'additionalFrontUserInfo.active' | translate }}
        </mat-header-cell>
        <mat-cell *matCellDef="let item" class="status">
          @if (item.active) {
            <mat-icon class="active">check_circle_outline</mat-icon>
          }
          @if (!item.active) {
            <mat-icon class="no_active">highlight_off</mat-icon>
          }
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="showOnTable">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="status">
          {{ 'additionalFrontUserInfo.showOnTable' | translate }}
        </mat-header-cell>
        <mat-cell *matCellDef="let item" class="status">
          @if (item.showOnTable) {
            <mat-icon class="active">check_circle_outline</mat-icon>
          }
          @if (!item.showOnTable) {
            <mat-icon class="no_active">highlight_off</mat-icon>
          }
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="columnName">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'additionalFrontUserInfo.columnName' | translate }}
        </mat-header-cell>
        <mat-cell *matCellDef="let item">
          <p class="text-truncate">{{ item.columnName }}</p>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
      <mat-row *matRowDef="let item; columns: displayedColumns;"
               class="event-row"
               matRipple
               (click)="editType(item)">
      </mat-row>
    </mat-table>

    @if (!dataSource || dataSource.length === 0) {
      <div class="no-data-msg">
        <span class="mat-headline-6">{{ 'main.noData' | translate }}</span>
      </div>
    }
  </div>
</pages-container>
